import { useState } from "react";
import { CartContext } from "lib/cartContext";
import { ProductContext } from "lib/productContext";

import PageLayout from "components/shared/pageLayout/PageLayout";
import Product from "components/product/Product";
import { addApolloState, initializeApollo } from "lib/apolloClient";
import { GetProductOptionsAndCart } from "../helpers/api/cadeauConcepten/queries/productPage.gql";

function Bestellen() {
    const [addingPackage, setAddingPackage] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [cartData, setCartData] = useState(null);
    const [cartLoading, setCartLoading] = useState(true);
    const [productData, setProductData] = useState(null);
    const [productLoading, setProductLoading] = useState(true);
    const [productError, setProductError] = useState(null);

    return (
        <CartContext.Provider
            value={{
                addingPackage,
                setAddingPackage,
                showOverlay,
                setShowOverlay,
                cartData,
                setCartData,
                cartLoading,
                setCartLoading
            }}
        >
            <ProductContext.Provider
                value={{
                    productData,
                    setProductData,
                    productLoading,
                    setProductLoading,
                    productError,
                    setProductError
                }}
            >
                <PageLayout
                    slug="lees-cadeaukaart-bestellen"
                    title="Lees! Cadeaukaart bestellen. Vandaag besteld = vandaag verzonden."
                    description=" Bestel hier jouw Lees! Cadeaukaart voor een boek, e-book of tijdschrift naar keuze. Zowel online als in de winkel in te wisselen. Waardes van 10,- tot 150,- euro."
                >
                    <Product />
                </PageLayout>
            </ProductContext.Provider>
        </CartContext.Provider>
    );
}

export async function getServerSideProps({ req }) {
    if (!process.env.featureFlags.ssr) {
        return {
            props: {}
        };
    }
    const apolloClient = initializeApollo();

    // Common product page variables
    const variables = {
        slug: "lees-Cadeau"
    };

    // Pass header cookie to context
    const context = {
        headers: {
            cookie: req?.headers?.cookie
        },
        timeout: 500
    };

    try {
        await apolloClient.query({
            query: GetProductOptionsAndCart,
            variables,
            context
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error?.message);
    }

    return addApolloState(apolloClient, { props: {} });
}

export default Bestellen;
